import { Button, Form, Upload as UploadAtnd } from "antd";
import { useTranslation } from "react-i18next";
import { uploadTransformer } from "components/services/data.transformers";
import { ReactComponent as UploadLogo } from "assets/icons/upload.svg";

const UploadFile = ({
  required,
  url,
  label,
  accept,
  isMaximSize,
  size,
  ...props
}) => {
  const { t } = useTranslation();

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  return (
    <Form.Item
      labelCol={{ xs: 24 }}
      wrapperCol={{ xs: 24 }}
      name="upload"
      label={label}
      valuePropName="fileList"
      getValueFromEvent={normFile}
      rules={[{ required: required, message: t("regex.empty") }]}
    >
      <UploadAtnd
        accept={accept}
        maxCount={1}
        className="w-full"
        {...uploadTransformer({ url, isMaximSize, size })}
        {...props}
      >
        <Button
          size="large"
          className="ltr flex items-center justify-center"
          block
          icon={<UploadLogo className="w-[18px] h-[18px]" />}
        >
          {t("payment.upload-receipt")}
        </Button>
      </UploadAtnd>
    </Form.Item>
  );
};
export default UploadFile;
